<script setup>
import { ref, computed, watch, defineEmits } from 'vue';
import IModal from '@components/IModal/IModal.vue';
import { translator } from '@shop/frontend/web/js/services/TranslatorService';

const props = defineProps({
  additionalServiceItemInfo: {
    type: String,
    default: '',
  },
  additionalServiceItemUid: {
    type: Number,
    default: 0,
  },
});

translator.getLanguages();


const emit = defineEmits();

const additionalServiceInfo = ref('')

const isButtonSubmitDisabled = computed(() => additionalServiceInfo.value.trim() === '');

function refundTickets() {
  emit('sendInfo', additionalServiceInfo.value, props.additionalServiceItemUid);
}

watch(() => props.additionalServiceItemUid, () => {
  additionalServiceInfo.value = props.additionalServiceItemInfo || ''; // Сбрасываем и обновляем ввод
});

</script>

<template>
  <IModal

    class="additional-service"
  >
    <template #header>
      <span class="additional-service__header additional-service-modal__header">
        {{ translator.t("main", "Additional data") }}
      </span>
    </template>
    <template #body>
      <div class="additional-service__body additional-service-modal__desc">
        <p class="additional-service__text">
          {{ translator.t("main", "Please provide the required information to purchase a parking space.") }}
        </p>
      </div>
      <div class="additional-service__tickets-wrapper additional-service-modal">
        <div class="additional-services__container">
          <input class="additional-services__info-input" v-model="additionalServiceInfo" type="text">
          <p class="additional-services__info-input-desc">{{ translator.t("main", "In format") }} N123NN 716</p>
        </div>
      </div>
      <div class="additional-service-modal__footer">
        <button
          type="button" class="btn" data-bs-dismiss="modal"
          :disabled="isButtonSubmitDisabled"
          @click="refundTickets"
        >
          {{ translator.t("main", "Add") }}
        </button>
      </div>
    </template>
  </IModal>
</template>

<style lang="scss">
@import '../../../../styles/custom/additional-services.scss';

button:disabled {
  opacity: 0.5;
}

.additional-service {
  .btn-close {
    position: absolute;
    color: $primary;
    top: 16px;
    right: 16px;
  }

  .modal-content {
    max-width: 496px;
    border: none;

    &_big-modal {
      position: fixed;
      transform: translate(-50%, -50%);
      left: 50%;
      top: 50%;
      max-width: unset;
    }
  }

  &__scheme-img {
    margin: 0 auto;
    display: block;
  }

  .modal-header {
    padding: 48px 48px 0 48px;
    margin-bottom: 16px;
  }

  .modal-body {
    padding: 0 48px 48px;
  }

  .additional-service__footer {
    width: 100%;

    .btn {
      padding: 9.5px 18px;
      margin: 0;
      width: 100%;
      font-weight: 500;
    }
  }

  &__place-old-price {
    text-decoration: line-through;
    margin-right: 16px;
  }

  &__header {
    font-size: 24px;
    font-weight: 700;
  }

  &__text {
    position: relative;
    margin-bottom: 12px;
    font-size: 14px;

    &:last-child {
      margin-bottom: 16px;
    }
  }

  &__places-list {
    padding: 0;
    margin-top: 10px;
    margin-bottom: 20px;
    list-style: none;
  }

  &__place {
    display: flex;
    align-items: center;
    justify-content: space-between;
    text-transform: capitalize;

    &:not(&:last-of-type) {
      margin-bottom: 12px;
    }
  }

  &__place_disabled {
    pointer-events: none;
    opacity: 0.5;

    .custom-checkbox {
      opacity: 0.5;
    }
  }

  &__price {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 16px;

    &:not(:last-of-type) {
      margin-bottom: 8px;
    }
  }

  &__price_selected {
    color: $grey-text;
  }

  &__agree-label {
    display: flex;
    align-items: center;
    gap: 11px;

    .custom-checkbox-input:checked ~ .custom-checkbox:after {
      opacity: 1;
    }
  }

  &__agree-label_sum {
    margin-bottom: 12px;
  }

  .custom-checkbox-input {
    position: absolute;
    z-index: -1;
    opacity: 0;
  }

  .custom-checkbox {
    position: relative;
    width: 20px;
    height: 20px;
    border: 1px solid $primary;
    display: flex;
    min-width: 20px;
    border-radius: 5px;
  }

  &__event_disabled {
    opacity: 0.5;
    pointer-events: none;
  }

  &__event-name {
    display: inline-block;
    margin-bottom: 10px;
    font-weight: 700;
    font-size: 18px;
  }

  &__tickets-wrapper {
    margin-bottom: 16px;
    padding: 16px 0 0;
  }

  &__info {
    display: block;
    font-size: 14px;
    color: $error;

    mark {
      background-color: transparent;
      text-decoration: underline;
      cursor: pointer;
    }
  }

  @media (max-width: $screen-xs) {
    .modal-dialog {
      margin: 0;
      height: 100%;
    }

    .modal-content {
      border-radius: 0;
      height: 100%;
      overflow-y: auto;
    }

    .modal-header {
      padding: 24px 16px 0;
    }

    .modal-body {
      padding: 0 16px 16px;
      flex: 0;
    }

    &__header {
      font-weight: 600;
      font-size: 20px;
    }

    &__text {
      margin-bottom: 16px;
      line-height: 19.6px;

      &:last-of-type {
        margin-bottom: 20px;
      }
    }
  }
}
</style>